<template>
  <div class="content-header">
    <div class="header">
      <div class="title">
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'ContentHeader',
  props: {
    title: String
  },
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.content-header {
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
  }
  .title {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    span {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #262626;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #ebebeb;
  }
}
</style>
